import axios from './config/axios'
const generatePreview = (data) => {
  return axios
    .post('/api/forms/preview', data)
    .then(r => r.data)
}
export default generatePreview